
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BlogShareButtons from "./ShareButton";

interface BlogPostFooterProps {
  title: string;
  url: string;
}

const BlogPostFooter: React.FC<BlogPostFooterProps> = ({ title, url }) => {
  return (
    <div className="mt-8 border-t border-joerg-100 pt-8 space-y-4">
      <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-4">
        <BlogShareButtons title={title} url={url} />
        
        <Link 
          to="/blog" 
          className="flex items-center text-joerg-700 dark:text-joerg-200 hover:text-primary dark:hover:text-primary-light font-medium transition-colors"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Blog-Übersicht
        </Link>
      </div>
      
      {/* RSS Feed Link */}
      <div className="flex justify-center">
        <a 
          href="/rss.xml" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-joerg-600 hover:text-primary transition-colors text-sm group"
          aria-label="RSS-Feed abonnieren"
        >
          <svg 
            className="w-4 h-4 group-hover:scale-110 transition-transform" 
            fill="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6.503 20.752c0 1.794-1.456 3.248-3.251 3.248-1.796 0-3.252-1.454-3.252-3.248 0-1.794 1.456-3.248 3.252-3.248 1.795.001 3.251 1.454 3.251 3.248zm-6.503-12.572v4.811c6.05.062 10.96 4.966 11.022 11.009h4.817c-.062-8.71-7.118-15.758-15.839-15.82zm0-3.368c10.58.046 19.152 8.594 19.183 19.188h4.817c-.03-13.231-10.755-23.954-24-24v4.812z"/>
          </svg>
          <span>Blog per RSS abonnieren</span>
        </a>
      </div>
    </div>
  );
};

export default BlogPostFooter;
